import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { WarrantyActivationFormService } from '@app/features/warranties/activate-warranty-process/steps/warranty-activation-form.service';
import { RetailersService } from '@src/app/shared/backend/clients';
import { firstValueFrom } from 'rxjs';
import { ComboData } from '@src/app/shared/components/comboData/comboData';

@Component({
    selector: 'app-retailer-selection',
    templateUrl: './retailer-selection.component.html',
    styleUrl: './retailer-selection.component.scss',
    host: {
        class: 'app-retailer-selection'
    },
    standalone: false
})
export class StepRetailerSelectionComponent implements OnInit {

  @Output() stepSaved = new EventEmitter<void>();

  comboData: ComboData = new ComboData(async (filter) => await firstValueFrom(this.retailersService.apiRetailersFilterComboPost(filter)));

  retailerSearchFormGroup: FormGroup = this.fb.group({
    retailerId: [[], [Validators.required]]
  });

  constructor(
    private fb: FormBuilder,
    private retailersService: RetailersService,
    private warrantyActivationFormService: WarrantyActivationFormService) { }

  async ngOnInit() {
    await this.initComboData();
    this.initFormStep();
  }

  private async initComboData() {
    await this.comboData.getData(null, 1);
  }

  async onLazyLoadComboData(event: any) {
    const search = event?.search?.trim() || null;
    const activePage = Math.max(1, (event?.pageIndex ?? 1));

    await this.comboData.getData(search, activePage);
  }

  getComboTotalPages(): number {
    const totalRecords = this.comboData?.totalRecords ?? 0;
    const pageSize = Number(this.comboData?.rowsPerPageOption) || 5;

    return Math.max(1, Math.ceil(totalRecords / pageSize));
  }

  initFormStep() {
    const stepData = this.warrantyActivationFormService.getStepData('retailerId');

    if (stepData != null) {
      this.retailerSearchFormGroup.patchValue({
        retailerId: [stepData]
      });
    }
  }

  onSaveStepData() {
    const retailerId = this.retailerSearchFormGroup.controls['retailerId'].value?.[0] ?? null;
    this.warrantyActivationFormService.setStepData('retailerId', retailerId);
    this.stepSaved.emit();
  }
}
